import React, { useState } from "react";
import styles from "./navbar.module.css";
import "./nav.css";
import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import TrainIcon from "@mui/icons-material/Train";
import DirectionsBusFilledIcon from "@mui/icons-material/DirectionsBusFilled";
import LocalTaxiIcon from "@mui/icons-material/LocalTaxi";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import DownhillSkiingIcon from "@mui/icons-material/DownhillSkiing";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Image1 from "../assest/img1.png";
import { Link } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("flights");

  return (
    <>
      <nav className={styles.navbarWrapper}>
        <div className={styles.navbarContent}>
          <div className={styles.leftSideNavbar}>
            <div className={styles.logoWrapper}>
              <a href="/" className={styles.logoimg}>
                <img src={Image1} alt="Logo" />
              </a>
            </div>
            <div
              className={styles.hamburgr_menu}
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <CloseIcon style={{ fontSize: "1.4em" }} />
              ) : (
                <MenuIcon style={{ fontSize: "1.4em" }} />
              )}
            </div>
          </div>
          <div
            className={
              open ? styles.rightSideNavbarMobile : styles.rightSideNavbar
            }
          >
            <div className={styles.iconWrapper}>
              <Link
                to="/"
                onClick={() => setActiveLink("flights")}
                className={
                  activeLink === "flights" ? "noDecoration" : "Decoration"
                }
              >
                <div
                  className={activeLink === "flights" ? styles.activeLink : ""}
                >
                  <span>
                    <FlightIcon
                      className={styles.flightICON}
                      style={{ fontSize: 30, padding: 4 }}
                    ></FlightIcon>
                    <p style={{ marginTop: "0px" }}>Flights</p>
                  </span>
                </div>
              </Link>
              <Link
                to="/hotel"
                onClick={() => setActiveLink("hotels")}
                className={
                  activeLink === "hotels" ? "noDecoration" : "Decoration"
                }
              >
                <div
                  className={activeLink === "hotels" ? styles.activeLink : ""}
                >
                  <span>
                    <HotelIcon style={{ fontSize: 30, padding: 4 }}></HotelIcon>
                  </span>
                  <p style={{ marginTop: "0px" }}>Hotels</p>
                </div>
              </Link>
              <div>
                <span>
                  <HomeWorkIcon
                    style={{ fontSize: 30, padding: 4 }}
                  ></HomeWorkIcon>
                </span>
                <p style={{ marginTop: "0px" }}>Homestays</p>
              </div>
              <Link
                to="/TrainSearch"
                onClick={() => setActiveLink("trains")}
                className={
                  activeLink === "trains" ? "noDecoration" : "Decoration"
                }
              >
                <div
                  className={activeLink === "trains" ? styles.activeLink : ""}
                >
                  <span>
                    <TrainIcon style={{ fontSize: 30, padding: 4 }}></TrainIcon>
                  </span>
                  <p style={{ marginTop: "0px" }}>Trains</p>
                </div>
              </Link>
              <div>
                <span>
                  <DirectionsBusFilledIcon
                    style={{ fontSize: 30, padding: 4 }}
                  ></DirectionsBusFilledIcon>
                </span>
                <p style={{ marginTop: "0px" }}>Buses</p>
              </div>
              <div>
                <span>
                  <LocalTaxiIcon
                    style={{ fontSize: 30, padding: 4 }}
                  ></LocalTaxiIcon>
                </span>
                <p style={{ marginTop: "0px" }}>Cabs</p>
              </div>
              <div>
                <span>
                  <CreditCardIcon
                    style={{ fontSize: 30, padding: 4 }}
                  ></CreditCardIcon>
                </span>
                <p style={{ marginTop: "0px" }}>Visa</p>
              </div>
              <div>
                <span>
                  <FlightTakeoffIcon
                    style={{ fontSize: 30, padding: 4 }}
                  ></FlightTakeoffIcon>
                </span>
                <p style={{ marginTop: "0px" }}>Charter flights</p>
              </div>
              <div>
                {/* <span> */}
                {/* <DownhillSkiingIcon
                    style={{ fontSize: 30, padding: 4 }}
                  ></DownhillSkiingIcon>
                </span>
                <p style={{ marginTop: "0px" }}>Activities</p> */}

                <Link
                  to="/Login"
                  onClick={() => setActiveLink("Login")}
                  className={
                    activeLink === "Login" ? "noDecoration" : "Decoration"
                  }
                >
                  <div
                    className={activeLink === "Login" ? styles.activeLink : ""}
                  >
                    <span>
                     <AccountCircleIcon
                        style={{ fontSize: 30, padding: 4 }}
                      ></AccountCircleIcon>
                    </span>
                    <p style={{ marginTop: "0px" }}>Login</p>
                  </div>
                </Link>
              </div>
            </div>

            {/* login container */}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
